export const dashboardConstants = {
    UPDATE_ASSESSEE: 'ADD_ASSESSEE',
    SET_ASSESSMENT: 'SET_ASSESSMENT',
    SET_ALL_ASSESSMENTS: 'SET_ALL_ASSESSMENTS',
    SET_ASSESSMENTS_HISTORY: 'SET_ASSESSMENTS_HISTORY',
}